/**
 * @generated SignedSource<<743e08a4bc673fe1e166a801b4f548dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpireDatePickerMutation$variables = {
  employeeId?: string | null;
  expireAt: string;
  productId: string;
};
export type ExpireDatePickerMutation$data = {
  readonly storeProduct: {
    readonly createExpireBatch: {
      readonly activeExpireBatches: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProductExpireDateListItem_StoreProductExpireBatch">;
      }>;
      readonly hasExpiredExpireDates: boolean;
      readonly hasPendingExpireDateActions: boolean;
      readonly id: string;
    } | null;
  } | null;
};
export type ExpireDatePickerMutation = {
  response: ExpireDatePickerMutation$data;
  variables: ExpireDatePickerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expireAt"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "expireAt",
    "variableName": "expireAt"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingExpireDateActions",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExpiredExpireDates",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExpireDatePickerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProductMutation",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "createExpireBatch",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "activeExpireBatches",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProductExpireDateListItem_StoreProductExpireBatch"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExpireDatePickerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProductMutation",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "createExpireBatch",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "activeExpireBatches",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchAction",
                    "kind": "LinkedField",
                    "name": "activeAction",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAtDate",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timezone",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "expireAtDate",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de17661f9ceee641036c1da9cb0c2089",
    "id": null,
    "metadata": {},
    "name": "ExpireDatePickerMutation",
    "operationKind": "mutation",
    "text": "mutation ExpireDatePickerMutation(\n  $productId: ID!\n  $expireAt: String!\n  $employeeId: ID\n) {\n  storeProduct(id: $productId) {\n    createExpireBatch(expireAt: $expireAt, employeeId: $employeeId) {\n      id\n      hasPendingExpireDateActions\n      hasExpiredExpireDates\n      activeExpireBatches {\n        id\n        ...ProductExpireDateListItem_StoreProductExpireBatch\n      }\n    }\n  }\n}\n\nfragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireDateListItem_StoreProductExpireBatch on StoreProductExpireBatch {\n  activeAction {\n    ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction\n    id\n  }\n  expireAtDate {\n    isoString\n  }\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "46e5dde507e70278cb4d58e72235316a";

export default node;
